import { render, staticRenderFns } from "./StudioDetails.vue?vue&type=template&id=41e24fd8"
import script from "./StudioDetails.vue?vue&type=script&lang=js"
export * from "./StudioDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports